<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <a-card
      v-if="open_repair_service==='YES'"
      :bordered="false"
      title="通知管理"
    >
      <a-button
        slot="extra"
        class="mr-10"
        @click="handleReset"
      >
        重置
      </a-button>
      <a-button
        slot="extra"
        type="primary"
        :loading="confirmLoading"
        @click="handleConfirm"
      >
        保存
      </a-button>
      <a-form-model
        ref="form"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <div
          v-for="(item, index) in phone_data"
          :key="'data' + index"
        >
          <a-form-model-item :label="item['brand_name']">
            <a-button type="primary" size="small" v-if="item.repair_notice_phone.length < 4" @click="addOption(index)">添加选项</a-button>
            <div v-if="item.repair_notice_phone" v-for="(val, key) in item.repair_notice_phone" :key="key">
              <a-input-number style="width:200px;margin:0 15px 4px 0;" v-model="item.repair_notice_phone[key]"></a-input-number>
              <a-button type="danger" size="small" @click="delOption(index, key)">删除</a-button>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-card>
    <a-result v-else status="403" title="通知服务暂未开通" sub-title="无法使用，请联系业务经理进行升级"/>
  </a-spin>
</template>

<script>
import { getPhone, phoneSetting } from '@/api/repair'
import { checkService } from '@/api/maintain'

export default {
  name: 'MaintainSetting',
  components: {},
  data() {
    return {
      spinning: false,
      open_repair_service: 'YES',
      confirmLoading: false,
      labelCol: { xxl: { span: 2 }, xl: { span: 3 }, lg: { span: 4 }, md: { span: 5 }, sm: { span: 7 }, xs: { span: 8 } },
      wrapperCol: { xxl: { span: 22 }, xl: { span: 21 }, lg: { span: 20 }, md: { span: 19 }, sm: { span: 17 }, xs: { span: 16 } },
      formData: {},
      phone_data: []
    }
  },
  created() {
    this.checkService()
    this.getPre()
  },
  methods: {
    // 预加载
    getPre() {
      getPhone()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.phone_data = data
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 点击 确认 按钮
    handleConfirm() {
      const phone = this.phone_data
      // 如果为空，则删除，不符合则提示
      phone.forEach((item, index) => {
        var p_arr = item.repair_notice_phone
        for (let i = 0; i < p_arr.length; i++) {
          if (p_arr[i] === '') {
            p_arr.splice(i, 1)
          }
          if (p_arr[i] < 10000000000 || p_arr[i] > 19999999999) {
            p_arr.splice(i, 1)
            p_arr.push('')
            this.$message.error('手机号码格式错误')
            return
          }
        }
      })
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postEdit()
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 添加手机号组件
    addOption(index) {
      this.phone_data[index].repair_notice_phone.push('')
    },
    // 删除组件
    delOption(index, key) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          this.phone_data[index].repair_notice_phone.splice(key, 1)
        }
      })
    },
    postEdit() {
      const phone = this.phone_data
      phoneSetting(phone)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
    },
    // 点击 取消 按钮
    handleReset() {
      this.getPre()
    },
    // 检查服务
    checkService() {
      this.spinning = true
      checkService()
        .then((res) => {
          if (res.code === 200) {
            this.open_repair_service = res.data.open_repair_service
          } else {
            this.$message.error('检查服务失败')
          }
        })
        .catch((e) => {
          this.$message.error('检查服务失败')
        })
        .finally(() => {
          this.spinning = false
        })
    }
  }
}
</script>
